import UsageDatapoint from './datapoints/UsageDatapoint';
import VerboseDatapoint from './datapoints/VerboseDatapoint';
import { CustomData } from './datapoints/AriaDatapoint';
import { DatapointOptions } from 'owa-analytics-actions';
import { DatapointStatus } from './types/DatapointEnums';
import { lazyLogDatapoint } from './LazyAnalytics';
import { PerformanceDatapoint } from './datapoints/PerformanceDatapoint';

export function logUsage(
    eventName: string,
    customData?: CustomData,
    options?: DatapointOptions
): void {
    lazyLogDatapoint.importAndExecute(new UsageDatapoint(eventName, customData, options));
}

export function logVerboseUsage(
    eventName: string,
    customData?: CustomData,
    options?: DatapointOptions
): void {
    let dp = new VerboseDatapoint(eventName, options);
    if (customData) {
        dp.addCustomData(customData);
    }
    dp.end();
}

export function logQoSSuccess(
    scenarioName: string,
    duration?: number,
    customData?: CustomData
): void {
    const performanceDatapoint = new PerformanceDatapoint(scenarioName, { isQos: true });
    if (customData) {
        performanceDatapoint.addCustomData(customData);
    }
    performanceDatapoint.end(duration);
}

export function logQoSFailure(
    scenarioName: string,
    duration?: number,
    status?: DatapointStatus,
    error?: Error,
    customData?: CustomData
): void {
    const performanceDatapoint = new PerformanceDatapoint(scenarioName, { isQos: true });
    if (customData) {
        performanceDatapoint.addCustomData(customData);
    }
    performanceDatapoint.endWithError(status || DatapointStatus.ClientError, error, duration);
}
